module.exports = __webpack_public_path__ + "static/media/pipeline_project.e05bdda7.jpg";